<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in keyWordTypeList">{{ item.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <!-- 筛选状态查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item title="状态">
              <!-- 关键字搜索 -->
              <!-- 选择搜索类型 -->
              <div style="display: flex;">
                <!--              <p style="width: 110px;height: 32px;border: 1px solid #333;">状态</p>-->
                <a-input placeholder="状态" disabled style="width: 80px;text-align: center;"></a-input>
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in statusList">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">搜索</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="clickOrderOutExcel" style="margin-right:15px;">导出</a-button>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text">{{ text | valInDict(statusList) }}</span>
      <span slot="role" slot-scope="text">{{ text | valInDict(dict.roleDict) }}</span>
      <span slot="action" slot-scope="text, record" >
        <template>
          <a @click="openViewModal(record.orderId)">查看</a>
        </template>
        <a-divider type="vertical" v-if="record.status==='NORMAL'"/>
        <template v-if="record.status==='NORMAL'">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openCancelModal(record.orderId)">取消订单</a>
          </a-dropdown>
        </template>
      </span>
    </tcg-table>
    <!-- 取消订单 -->
    <a-modal
      :visible="cancelModal"
      @cancel="hideCancelModal"
      @ok="handCancelOrder"
      :width="400"
      title="提示"
      cancelText="否"
      okText="是"
      style="z-index: 999;">
      <p>是否确认取消订单?</p>
    </a-modal>
    <!-- 查看弹出 -->
    <a-drawer
      placement="right"
      width="600"
      :closable="false"
      @close="cancelViewDrawer"
      :visible="viewVisible">
      <div>
        <div solt="title">
          <span style="font-size: 18px;font-weight: 700;">基本信息</span>
          <a-button style="float: right" @click="openCancelModal(orderId)" v-if="detail.status==='NORMAL'">取消订单</a-button>
        </div>
        <a-row style="margin-top: 50px;">
          <a-col span="6">订单号：</a-col>
          <a-col>{{ detail.orderId }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">企业简称：</a-col>
          <a-col>{{ detail.tenant_name }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">联系人名称：</a-col>
          <a-col>{{ detail.contacts }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">联系人电话：</a-col>
          <a-col>{{ detail.contact_number }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">状态：</a-col>
          <a-col>{{ detail.status | valInDict(statusList) }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">云码数量：</a-col>
          <a-col>{{ detail.security_code_count }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">订单金额：</a-col>
          <a-col>{{ detail.total_price }}元</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">支付方式：</a-col>
          <a-col>{{ detail.pay_type==='WEIXIN'?'微信扫码':detail.pay_type==='ALIPAY'?'支付宝扫码':'' }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">最后更新时间：</a-col>
          <a-col>{{ detail.update_time }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">创建时间：</a-col>
          <a-col>{{ detail.create_time }}</a-col>
        </a-row>
      </div>
    </a-drawer>
  </a-card>
</template>
<script>
import { getRechargeList, getRechargeDetail, cancelOrder, orderPre } from '@/api/order'
import { TcgTable } from '@/components'
import _ from 'lodash'
export default {
  components: {
    TcgTable
  },
  data () {
    return {
      // 取消订单弹窗
      cancelModal: false,
      // 添加抽屉状态开关
      addDrawerVisible: false,
      // 编辑抽屉状态开关
      editDrawerVisible: false,
      // 设置权限抽屉开关
      rolePermissionVisible: false,
      // 关键字搜索类型列表
      keyWordTypeList: '',
      // 状态字典
      statusList: '',
      // 字典
      dict: {
        orderStatusDict: [],
        keyWordTypeDict: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        // page: 1,
        // size: 15,
        status: '',
        keyWordType: 'orderId',
        keyWord: ''
      },
      // 表头
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderId',
          width: '100px'
        },
        {
          title: '云码数量',
          dataIndex: 'security_code_count',
          width: '100px'
        },
        {
          title: '充值金额(元)',
          dataIndex: 'total_price',
          width: '120px'
        },
        {
          title: '企业简称',
          dataIndex: 'tenant_name',
          width: '100px'
        },
        {
          title: '联系人名称',
          dataIndex: 'contacts',
          width: '100px'
        },
        {
          title: '联系人电话',
          dataIndex: 'contact_number',
          width: '100px'
        },
        {
          title: '业务经理',
          dataIndex: 'business_manager',
          width: '100px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '最后更新时间',
          dataIndex: 'update_time',
          width: '180px',
          scopedSlots: { customRender: 'lastTime' }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '180px',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '200px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getRechargeList(Object.assign(parameter, this.queryParam)).then(res => {
          return res
        })
      },
      viewVisible: false,
      orderId: '',
      detail: '',
      defalutPermissionArr: []
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      orderPre().then(res => {
        console.log(res)
        if (_.get(res, 'code') === 200) {
          this.statusList = _.get(res, 'data.orderStatusDict', [])
          this.keyWordTypeList = _.get(res, 'data.keyWordTypeDict', [])
          const all = {
            id: '',
            name: '全部'
          }
          this.statusList.unshift(all)
        }
      })
    },
    // 获取详情
    getDetail () {
      const params = {
        orderId: this.orderId
      }
      getRechargeDetail(params).then(res => {
        console.log(res)
        if (_.get(res, 'code') === 200) {
          this.detail = _.get(res, 'data', [])
          console.log(this.detail)
        }
      })
    },
    // 导出功能
    clickOrderOutExcel () {
      setTimeout(function() {
        window.location.href = window.location.origin + '/admin.php/order/orderOutExcel?order_type=RECHARGE'
      }, 1000)
    },
    // 重置按钮
    reset () {
      this.queryParam.status = ''
      this.queryParam.keyWordType = 'orderId'
      this.queryParam.keyWord = ''
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      console.log(id)
      this.orderId = id
      this.viewVisible = true
      this.getDetail()
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 完成创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加用户抽屉
    openAddDrawer () {
      this.addDrawerVisible = true
    },
    // 关闭添加用户抽屉
    handelAddDrawer () {
      this.addDrawerVisible = false
    },
    // 打开权限设置抽屉
    openRolePermission (record) {
      this.role_id = record.role_id
      this.defalutPermissionArr = record.role_auth.split(',')
      for (const i in this.defalutPermissionArr) {
        this.defalutPermissionArr[i] = parseInt(this.defalutPermissionArr[i])
      }
      this.rolePermissionVisible = true
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
      this.$refs.table.refresh(true)
    },
    // 打开编辑抽屉
    openEditDrawer (id) {
      this.userId = id
      this.editDrawerVisible = true
    },
    // 关闭编辑抽屉
    handelEditDrawer () {
      this.editDrawerVisible = false
    },
    // 打开取消订单弹窗
    openCancelModal (id) {
      this.orderId = id
      this.cancelModal = true
    },
    // 确认取消订单
    cancelOrder (id) {
      this.cancelId = id
    },
    // 关闭取消订单弹窗
    hideCancelModal () {
      this.cancelModal = false
    },
    // 删除事件
    handCancelOrder () {
      const parameter = {
        order_type: 'RECHARGE',
        orderId: this.orderId
      }
      cancelOrder(parameter).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('取消成功')
          this.cancelModal = false
          this.$refs.table.refresh(true)
        } else {
          this.cancelModal = false
        }
      })
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
